/**
 * @author SwathiDivya Bhavaraju
 * @email swathidivya.bhavaraju@ul.com
 * @create date 2021-04-22 12:20:32
 * @modify date 2021-04-22 12:20:32
 * @desc [description]
 */
<template>
  <div class="row m-0">
    <div class="col-md-12 col-lg-12 col-sm-12 p-0">
      <div class="p-0 col-xs-12 first_table" v-if="servicesList.length">
        <table class="table activity-tracker-table">
          <thead>
            <tr>
              <template v-for="header in tableHeaders">
                <th
                  v-if="header !== 'plan_id'"
                  :key="header"
                  :class="{ 'w-35': header==='name' }"
                >
                  {{ header | capitalize }}
                  <!-- <span
              class="arrow"
              :class="sortOrders[header] > 0 ? 'asc' : 'dsc'"
            ></span> -->
                </th>
              </template>
              <th class="w-6"></th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(service) in servicesList"
              :key="service.id"
               :class="{
               'greyout': !service.active
              }"
            >
              <template v-for="header in tableHeaders">
                <td
                  :key="header"
                  v-if="header !== 'plan_id'"
                >
                <div v-if="['added_date', 'expiry_date'].includes(header)">
                  {{service[header] | dateFormatter}}
                </div>
                <div v-else-if="header === 'active'">
                  <img v-if="service[header]" src="/static/images/icons/check.svg" alt="check-icon"/>
                </div>
                <div v-else-if="header === 'name' && !service.active">
                  <span>{{service[header]}} <img src="/static/images/icons/expiry-grey.svg" class="image-size" alt="expiry-icon"/></span>
                </div>
                <div v-else>{{service[header]}}</div>
                </td>
              </template>
               <td>
                <div class="account_header_content cursor-pointer"  @click="routeURL('/layout/prodclassificationactivitytracker')">
                    <img src="/static/images/icons/chevron_right.svg" v-if="service.plan_id === 7" alt="chevron-right-icon"/>
                </div>
               </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-else class="norecords_wrapper p-20">
        <div class="no-records-found">No Records Found</div>
      </div>
      <loader :loadingStatus="loaderStatus"></loader>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
import Loader from '../UIComponents/Loader.vue';
import { getAccountServices } from '../../apis/accountDetails';

export default {
  components: { Loader },
  props: ['accountId'],
  data() {
    return {
      loaderStatus: false,
      servicesList: [],
      tableHeaders: [],
      // sortKey: '',
      // sortOrders: {},
    };
  },
  filters: {
    dateFormatter(date) {
      return date ? moment(date).format('DD/MM/YYYY') : '';
    },
    capitalize(value) {
      if (!value) return '';
      const returnVal = value.replace(/_/g, ' ').toString();
      return returnVal
        .toLowerCase()
        .split(' ')
        .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
        .join(' ');
    },
  },
  methods: {
    routeURL(url) {
      sessionStorage.setItem('getAccountDetailsId', this.accountId);
      this.$router.push(url);
    },
    async getServices() {
      this.loaderStatus = true;
      const response = await getAccountServices(this.accountId);
      this.loaderStatus = false;
      if (response.status_code !== 200) {
        this.$notify({
          clear: true,
          group: 'custom-notification',
        });
        this.$notify({
          type: 'error',
          title: 'Error',
          text: 'Unable to fetch services',
          group: 'custom-notification',
        });
      } else {
        this.servicesList = response.data;
        this.tableHeaders = this.servicesList.length ? Object.keys(this.servicesList[0]) : [];
      }
    },

    // sortBy(sortHeader) {
    //   this.sortKey = sortHeader;
    //   this.sortOrders[sortHeader] *= -1;
    //   const order = this.sortOrders[sortHeader] > 0 ? 'asc' : 'desc';
    //   this.servicesList = orderBy(this.servicesList, [sortHeader], [order]);
    // },

    // setDefaultSortValues() {
    //   this.sortOrders = this.tableHeaders.reduce((acc, header) => {
    //     acc[header] = 1;
    //     return acc;
    //   }, {});
    // },

  },
  async created() {
    await this.getServices();
    // this.setDefaultSortValues();
  },
};
</script>
<style scoped>
.image-size{
  vertical-align: sub;
}
.activity-tracker-table.table > tbody > tr > td,
.activity-tracker-table.table > thead > tr > th {
  padding-left : 15px !important;
}
.activity-tracker-table.table > tbody > tr.greyout > td{
  color:rgb(0,0,0,0.4);
}
.w-35 {
  width: 35%;
}
.w-6 {
  width: 6%;
}
.first_table th:hover .arrow {
  opacity: 0.5;
}
.first_table .arrow.asc {
  border-bottom: 6px solid #BDBDBD;
}
.first_table .arrow.dsc {
  border-top: 6px solid #BDBDBD;
}
</style>
